module.exports = __webpack_public_path__ + "static/media/box-usd.ecba11a3.svg";